import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  sliders: [],
  current_slider: false,
  videoAdv: [],
  allVideosAdv: [],
  current_video: false,
  diagnosticAlerts: [],
  localActions: []
};

// getters
const getters = {
  getSliders: (state, getters, rootState) => {
    return state.sliders;
  },

  getCurrentSlider: (state, getters, rootState) => {
    return state.current_slider;
  },

  getVideoAdv: (state, getters, rootState) => {
    return state.videoAdv;
  },

  getAllVideoAdv: (state, getters, rootState) => {
    return state.allVideosAdv;
  },
  getCurrentVideo: (state, getters, rootState) => {
    return state.current_video;
  },
  getDiagnosticAlerts: (state, getters, rootState) => {
    return state.diagnosticAlerts;
  },
  getLocalActions: (state, getters, rootState) => {
    return state.localActions;
  }
};

// actions
const actions = {
  loadSliders({ commit }) {
    return api.get("slider").then(function(response) {
      if (response.status) {
        var data = response.data;

        return commit("setSliders", response.data);
      }
    });
  },

  uploadSlider({ commit }, slider) {
    if (typeof slider.file !== "string") {
      var uploaderFile = new Uploader();
      uploaderFile.upload(slider.file, { path: "sliders" }, function(data) {
        slider.file = data.Location;
        var path = slider.id == -1 ? "add" : slider.id + "/update";
        return api.post("slider/" + path, slider).then(function(data) {
          console.log(data);
          if (data.status) {
            var sliderServer = JSON.parse(JSON.stringify(data.data));
            return commit("addSlider", sliderServer);
          }
        });
      });
    } else {
      var path = slider.id == -1 ? "add" : slider.id + "/update";
      return api.post("slider/" + path, slider).then(function(data) {
        console.log(data);
        if (data.status) {
          var sliderServer = JSON.parse(JSON.stringify(data.data));
          return commit("addSlider", sliderServer);
        }
      });
    }
  },

  removeSlider({ commit }, id) {
    return api.get("slider/" + id + "/delete").then(function(response) {
      if (response.status) {
        var data = response.data;

        return commit("removeSlider", id);
      }
    });
  },

  logSlider: ({ commit }, data) => {
    return api.get("slider/log/" + data.slider_id + "/" + data.user_id);
  },

  loadVideoAdv({ commit }) {
    return api.get("video").then(function(response) {
      if (response.status) {
        return commit("setVideoAdv", response.data);
      }
    });
  },

  loadAllVideosAdv({ commit }) {
    return api.get("video/all").then(function(response) {
      if (response.status) {
        return commit("setAllVideosAdv", response.data);
      }
    });
  },

  addVideoAdv({ commit }, video) {
    return api.post("video/add", video).then(function(data) {
      console.log(data);
      if (data.status) {
        // var sliderServer = JSON.parse(JSON.stringify(data.data));
        return commit("addVideoAdv", video);
      }
    });
  },

  editVideoAdv({ commit }, video) {
    return api.post("video/edit", video).then(function(data) {
      console.log(data);
      if (data.status) {
        // var sliderServer = JSON.parse(JSON.stringify(data.data));
        return commit("addVideoAdv", video);
      }
    });
  },

  removeVideoAdv({ commit }, id) {
    return api.get("video/" + id + "/delete").then(function(response) {
      if (response.status) {
        return commit("removeVideoAdv", id);
      }
    });
  },

  loadDiagnosticAlerts: ({ commit, dispatch }, iRestaurant) => {
    return api
      .post("diagnostic/alerts", { restaurant_id: iRestaurant })
      .then(function(response) {
        if (response.status) {
          return commit("setDiagnosticAlerts", response.data);
        }
      });
  },

  loadLocalActions: ({ commit, dispatch }, iRestaurant) => {
    return api
      .post("actions", { restaurant_id: iRestaurant })
      .then(function(response) {
        if (response.status) {
          return commit("setLocalActions", response.data);
        }
      });
  }
};

// mutations
const mutations = {
  setSliders(state, sliders) {
    state.sliders = sliders;
  },

  setCurrentSlider(state, slider) {
    state.current_slider = slider;
  },

  setCurrentSliderByID(state, id) {
    state.current_slider = state.sliders[id];
  },

  addSlider(state, slider) {
    var sliders = { ...state.sliders };
    sliders[slider.id] = slider;

    state.sliders = sliders;
  },

  removeSlider(state, id) {
    var sliders = { ...state.sliders };
    delete sliders[id];

    state.sliders = sliders;
  },

  setVideoAdv(state, video) {
    state.videoAdv = video;
  },

  setAllVideosAdv(state, videos) {
    state.allVideosAdv = videos;
  },

  setCurrentVideo(state, video) {
    console.log(video);
    state.current_video = video;
  },

  setCurrentVideoByID(state, id) {
    state.current_video = state.allVideosAdv[id];
  },

  addVideoAdv(state, video) {
    var videos = { ...state.allVideosAdv };
    videos[video.id] = video;

    state.allVideosAdv = videos;
  },

  removeVideoAdv(state, id) {
    var video = { ...state.allVideosAdv };
    delete video[id];

    state.allVideosAdv = video;
  },

  setDiagnosticAlerts(state, alerts) {
    state.diagnosticAlerts = alerts;
  },

  setLocalActions(state, actions) {
    state.localActions = actions;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
